import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../../api/hooks/useColors";

export default function SummaryStep({ remediation }) {
  const colors = useColors();

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="column" gap={0.5}>
        <Typography variant="subtitle2" color={colors.text_primary}>
          Remediation Summary
        </Typography>
        <Typography variant="body2" color={colors.text_secondary}>
          The following actions will be applied to the selected entities:
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gap={3}
        border={"1px solid " + colors.divider}
        borderRadius="10px"
        padding="24px"
        sx={{ backgroundColor: colors.common_white }}
      >
        <Box display="flex" flexDirection="column" gap={0.5}>
          <Typography variant="subtitle2" color={colors.text_primary}>
            What Breeze Will Do?
          </Typography>
          {[
            ...remediation.remediation_list,
            "Log this change in the audit history.",
          ].map((step, index) => (
            <Typography variant="body2" color={colors.text_primary}>
              <b>{index + 1}.</b>
              <span style={{ paddingLeft: "8px" }}>{step}</span>
            </Typography>
          ))}
        </Box>
        <Box>
          <Typography variant="subtitle2" color={colors.text_primary}>
            How long would it take?
          </Typography>
          <Typography variant="body2" color={colors.text_primary}>
            Less than 1 minute.{" "}
          </Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color={colors.text_primary}>
            Is the fix reversible?
          </Typography>
          <Typography variant="body2" color={colors.text_primary}>
            Yes — you can undo this remediation from the Review Remediation
            screen, or apply it later to additional entities.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
